<script>
  import { link } from "svelte-routing";
  import OffersSafetyMattersPriorBooking from "../components/OffersSafetyMattersPriorBooking.svelte";
</script>

<div class="page-id-3959">
  <div id="content" class="site-content">
    <div class="image-background">
      <h1 class="header_text_wrapper text-left">
        <span>Day Out Packages</span><span class="separator"></span>
      </h1>
    </div>
    <div class="primary content-area container-fluid">
      <main id="main" class="site-main main-content content-width">
        <article
          id="post-3959"
          class="post-3959 page type-page status-publish hentry"
        >
          <div class="page-content d-flex flex-wrap gap-20 top-35 bottom-35">
            <div class="day_out_box">
              <div class="day_out_mainbox wpb_column vc_column_container">
                <div class="vc_column-inner">
                  <div class="wpb_wrapper">
                    <div class="calluna-pricing calluna- calluna-column-">
                      <div class="calluna-pricing-header">
                        <h4 style="background-color:#641e16;opacity:1">
                          Full Mango
                        </h4>
                        <div class="calluna-pricing-content">
                          <strong>Activities :</strong> Twenty adventure game
                          Coupons ( 11yrs and above ) , pool access, mist dance,
                          use of standard facilities of the resort.
                          <br /> <strong>Food and Beverage :</strong> Welcome
                          beverage, breakfast, lunch buffet, Hi tea, Live BBQ
                          (one veg or non-veg platter) + a beverage (alcoholic
                          or non alcoholic) at the bar , Dinner Buffet.
                          <ul>
                            <li><strong>Duration :</strong> 9am to 10pm</li>
                            <li>
                              <a
                                class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox"
                                href="https://www.mangomist.com/fullmango.html" target="_blank"
                                >View Details</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div><strong>INR 3240 Per Adult</strong></div>
                        <div><strong>INR 1,620 per Kid</strong></div>
                        ( Taxes applicable )
                      </div>
                      <div class="calluna-pricing-button">
                        <a
                          href="http://bookings.mangomist.com/dayoutpacks.php?type=c&amp;p=fm"
                          class="calluna-button btn btn-primary style-1"
                          rel="nofollow"
                          ><span class="calluna-button-inner"
                            ><span class="calluna-button-icon-left fa fa-adjust"
                            ></span>Book Getaway<span
                              class="calluna-button-icon-right fa fa-adjust"
                            ></span></span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="day_out_mainbox wpb_column vc_column_container">
                <div class="vc_column-inner">
                  <div class="wpb_wrapper">
                    <div class="calluna-pricing calluna- calluna-column-">
                      <div class="calluna-pricing-header">
                        <h4 style="background-color:#7d6608;opacity:1">
                          Three Quarter Mango
                        </h4>
                        <div class="calluna-pricing-content">
                          <div class="gmail_default">
                            <b>Activities : </b>Twelve adventure game Coupons (
                            11yrs and above ), pool access, mist dance, use of
                            standard facilities of the resort.
                          </div>
                          <div class="gmail_default">
                            <b>Food and Beverage :&nbsp;</b>Welcome beverage,
                            breakfast,&nbsp;lunch buffet, Hi tea.
                          </div>
                          <ul>
                            <li><strong>Duration :</strong> 9am to 6pm</li>
                            <li>
                              <a
                                class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox"
                                href="https://www.mangomist.com/tqm.html" target="_blank"
                                >View Details</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div><strong>INR 2240 Per Adult</strong></div>
                        <div><strong>INR 1120 Per Kid</strong></div>
                        ( Taxes applicable )
                      </div>
                      <div class="calluna-pricing-button">
                        <a
                          href="http://bookings.mangomist.com/dayoutpacks.php?type=c&amp;p=tqm"
                          class="calluna-button btn btn-primary style-1"
                          rel="nofollow"
                          ><span class="calluna-button-inner"
                            ><span class="calluna-button-icon-left fa fa-adjust"
                            ></span>Book Getaway<span
                              class="calluna-button-icon-right fa fa-adjust"
                            ></span></span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vc_row wpb_row vc_row-fluid">
              <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="vc_column-inner">
                  <div class="wpb_wrapper">
                    <div class="vc_empty_space" style="height: 24px">
                      <span class="vc_empty_space_inner"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vc_row wpb_row vc_row-fluid day_out_box">
              <div class="day_out_mainbox wpb_column vc_column_container">
                <div class="vc_column-inner">
                  <div class="wpb_wrapper">
                    <div class="calluna-pricing calluna- calluna-column-">
                      <div class="calluna-pricing-header">
                        <h4 style="background-color:#4a235a;opacity:1">
                          Golden Mango Lunch
                        </h4>
                        <div class="calluna-pricing-content">
                          <div>
                            <div class="gmail_default">
                              <b>Activities : </b>Twelve adventure game Coupons
                              ( 11yrs and above ), pool access, mist dance, use
                              of standard facilities of the resort.
                            </div>
                            <div class="gmail_default">
                              <b>Food and Beverage :&nbsp;</b>Welcome
                              beverage,&nbsp;Live BBQ (one veg or non-veg
                              platter) + a beverage (alcoholic or non alcoholic)
                              at the bar,&nbsp;lunch buffet, Hi tea.
                            </div>
                          </div>
                          <ul>
                            <li><strong>Duration :</strong> 11am to 6pm</li>
                            <li>
                              <a
                                class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox"
                                href="https://www.mangomist.com/goldenmango.html" target="_blank"
                                >View Details</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div><strong>INR 2240 Per Adult</strong></div>
                        <div><strong>INR 1170 Per Kid</strong></div>
                        ( Taxes applicable )
                      </div>
                      <div class="calluna-pricing-button">
                        <a
                          href="http://bookings.mangomist.com/dayoutpacks.php?type=c&amp;p=gml"
                          class="calluna-button btn btn-primary style-1"
                          rel="nofollow"
                          ><span class="calluna-button-inner"
                            ><span class="calluna-button-icon-left fa fa-adjust"
                            ></span>Book Getaway<span
                              class="calluna-button-icon-right fa fa-adjust"
                            ></span></span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="day_out_mainbox wpb_column vc_column_container">
                <div class="vc_column-inner">
                  <div class="wpb_wrapper">
                    <div class="calluna-pricing calluna- calluna-column-">
                      <div class="calluna-pricing-header">
                        <h4 style="background-color:#154360;opacity:1">
                          Half Mango Lunch
                        </h4>
                        <div class="calluna-pricing-content">
                          <div class="gmail_default">
                            <b>Activities : </b>Twelve adventure game Coupons (
                            11yrs and above ), pool access, mist dance, use of
                            standard facilities of the resort.
                          </div>
                          <div class="gmail_default">
                            <b>Food and Beverage :&nbsp;</b>Welcome
                            beverage,&nbsp;lunch buffet, Hi tea.
                          </div>
                          <p>.</p>
                          <ul>
                            <li>
                              <a
                                class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox"
                                href="https://www.mangomist.com/halfmangolunch.html" target="_blank"
                                >View Details</a
                              >
                            </li>
                            <li><strong>Duration :</strong> 11am to 6pm</li>
                          </ul>
                        </div>
                        <div><strong>INR 1940 Per Adult</strong></div>
                        <div><strong>INR 970 Per Kid</strong></div>
                        ( Taxes applicable )
                      </div>
                      <div class="calluna-pricing-button">
                        <a
                          href="http://bookings.mangomist.com/dayoutpacks.php?type=c&amp;p=hml"
                          class="calluna-button btn btn-primary style-1"
                          rel="nofollow"
                          ><span class="calluna-button-inner"
                            ><span class="calluna-button-icon-left fa fa-adjust"
                            ></span>Book Getaway<span
                              class="calluna-button-icon-right fa fa-adjust"
                            ></span></span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="vc_row wpb_row vc_row-fluid">
              <div class="wpb_column vc_column_container vc_col-sm-12">
                <div class="vc_column-inner">
                  <div class="wpb_wrapper">
                    <div class="vc_empty_space" style="height: 24px">
                      <span class="vc_empty_space_inner"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="vc_row wpb_row vc_row-fluid day_out_box svelte-1wboxoc">
              <div
                class="day_out_mainbox wpb_column vc_column_container svelte-1wboxoc"
              >
                <div class="vc_column-inner svelte-1wboxoc">
                  <div class="wpb_wrapper">
                    <div
                      class="calluna-pricing calluna- calluna-column- svelte-1wboxoc"
                    >
                      <div class="calluna-pricing-header svelte-1wboxoc">
                        <h4
                          class="svelte-1wboxoc"
                          style="background-color: rgb(120, 66, 18); opacity: 1;"
                        >
                          Golden Mango Dinner
                        </h4>
                        <div class="calluna-pricing-content svelte-1wboxoc">
                          <div class="gmail_default">
                            <div>
                              <b>Activities : </b>Twelve adventure game Coupons
                              ( 11yrs and above ), pool access, mist dance, use
                              of standard facilities of the resort.
                            </div>
                            <div class="gmail_default">
                              <b>Food and Beverage :&nbsp;</b>Welcome beverage,
                              Hi tea,&nbsp;Live BBQ (one veg or non-veg platter)
                              + a beverage (alcoholic or non alcoholic) at the
                              bar,&nbsp;dinner buffet.
                            </div>
                          </div>
                          <ul class="svelte-1wboxoc">
                            <li class="svelte-1wboxoc">
								<strong>Duration :</strong> 3pm to 10pm
                            </li>
                            <li class="svelte-1wboxoc">
                              <a
                                class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox"
                                href="https://www.mangomist.com/goldenmangodinner.html" target="_blank"
                                contenteditable="false"
                                style="cursor: pointer;">View Details</a
                              >
                            </li>
                          </ul>
                        </div>
						<div>
							<strong>
								INR 1890 Per Adul
							</strong>
						</div>
						<div>
							<strong>
								INR 945 Per Kid
							</strong>
						</div>
						( Taxes applicable )
                      </div>
                      <div class="calluna-pricing-button svelte-1wboxoc">
                        <a
                          href="http://bookings.mangomist.com/dayoutpacks.php?type=c&amp;p=gmd"
                          class="calluna-button btn btn-primary style-1 svelte-1wboxoc"
                          rel="nofollow"
                          contenteditable="false"
                          style="cursor: pointer;"
                          ><span class="calluna-button-inner"
                            ><span class="calluna-button-icon-left fa fa-adjust"
                            ></span>Book Getaway<span
                              class="calluna-button-icon-right fa fa-adjust"
                            ></span></span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="day_out_mainbox wpb_column vc_column_container svelte-1wboxoc"
              >
                <div class="vc_column-inner svelte-1wboxoc">
                  <div class="wpb_wrapper">
                    <div
                      class="calluna-pricing calluna- calluna-column- svelte-1wboxoc"
                    >
                      <div class="calluna-pricing-header svelte-1wboxoc">
                        <h4
                          class="svelte-1wboxoc"
                          style="background-color: rgb(11, 83, 69); opacity: 1;"
                        >
                          Half Mango Dinner
                        </h4>
                        <div class="calluna-pricing-content svelte-1wboxoc">
                          <div>
                            <b>Activities : </b>Twelve adventure game Coupons (
                            11yrs and above ), pool access, mist dance, use of
                            standard facilities of the resort.
                          </div>
                          <div class="gmail_default">
                            <b>Food and Beverage :&nbsp;</b>Welcome beverage, Hi
                            tea,&nbsp;dinner buffet.
                          </div>
                          <div class="gmail_default"></div>
                          <div class="gmail_default"></div>
                          <ul class="svelte-1wboxoc">
                            <li class="svelte-1wboxoc">
								<strong>Duration :</strong> 3pm to 10pm
                            </li>
                            <li class="svelte-1wboxoc">
                              <a
                                class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox"
                                href="https://www.mangomist.com/halfmangodinner.html" target="_blank"
                                contenteditable="false"
                                style="cursor: pointer;">View Details</a
                              >
                            </li>
                          </ul>
                        </div>
						<div>
							<strong>
								INR 1690 Per Adult
							</strong>
						</div>
                        <div>
							<strong>
								INR 845 Per Kid
							</strong>
						</div>
						( Taxes applicable )
                      </div>
                      <div class="calluna-pricing-button svelte-1wboxoc">
                        <a
                          href="http://bookings.mangomist.com/dayoutpacks.php?type=c&amp;p=hmd"
                          class="calluna-button btn btn-primary style-1 svelte-1wboxoc"
                          rel="nofollow"
                          contenteditable="false"
                          style="cursor: pointer;"
                          ><span class="calluna-button-inner"
                            ><span class="calluna-button-icon-left fa fa-adjust"
                            ></span>Book Getaway<span
                              class="calluna-button-icon-right fa fa-adjust"
                            ></span></span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vc_row wpb_row vc_row-fluid day_out_box svelte-1wboxoc">
              <div
                class="day_out_mainbox wpb_column vc_column_container svelte-1wboxoc"
              >
                <div class="vc_column-inner svelte-1wboxoc">
                  <div class="wpb_wrapper">
                    <div
                      class="calluna-pricing calluna- calluna-column- svelte-1wboxoc"
                    >
                      <div class="calluna-pricing-header svelte-1wboxoc">
                        <h4
                          class="svelte-1wboxoc"
                          style="background-color: rgb(183, 149, 11); opacity: 1;"
                        >
                          Three Quarters Mango (With Team Building)
                        </h4>
                        <div class="calluna-pricing-content svelte-1wboxoc">
                          <div class="gmail_default">
                            <b>Activities :&nbsp;</b>Team building activities (2
                            hours), Twelve adventure game Coupons ( 12yrs and
                            above ), pool access, mist dance, use of standard
                            facilities of the resort.
                          </div>
                          <div class="gmail_default">
                            <b>Food and Beverage :&nbsp;</b>Welcome beverage,
                            breakfast,&nbsp;lunch buffet, Hi tea.
                          </div>
                          <ul class="svelte-1wboxoc">
                            <li class="svelte-1wboxoc"><strong>Duration :</strong> 9am to 6pm</li>
                            <li class="svelte-1wboxoc">
                              Minimum group size 50 and above
                            </li>
                            <li class="svelte-1wboxoc">
                              <a
                                class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox"
                                href="https://www.mangomist.com/tqm_tba.html" target="_blank"
                                contenteditable="false"
                                style="cursor: pointer;">View Details</a
                              >
                            </li>
                          </ul>
                        </div>
						<div>
							<strong>
								INR 2540 Per Adult
							</strong>
						</div>
						( Taxes applicable )
                      </div>
                      <div class="calluna-pricing-button svelte-1wboxoc">
                        <a
                          href="contact"
                          class="calluna-button btn btn-primary style-1 svelte-1wboxoc"
                          rel="nofollow"
                          contenteditable="false"
                          style="cursor: pointer;"
                          ><span class="calluna-button-inner"
                            ><span class="calluna-button-icon-left fa fa-adjust"
                            ></span>Contact Us<span
                              class="calluna-button-icon-right fa fa-adjust"
                            ></span></span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="day_out_mainbox wpb_column vc_column_container svelte-1wboxoc"
              >
                <div class="vc_column-inner svelte-1wboxoc">
                  <div class="wpb_wrapper">
                    <div
                      class="calluna-pricing calluna- calluna-column- svelte-1wboxoc"
                    >
                      <div class="calluna-pricing-header svelte-1wboxoc">
                        <h4
                          class="svelte-1wboxoc"
                          style="background-color: rgb(123, 125, 125); opacity: 1;"
                        >
                          Drunken Mango Dinner
                        </h4>
                        <div class="calluna-pricing-content svelte-1wboxoc">
                          <div>
                            <div>
                              <b>Activities : </b>Twelve adventure game Coupons
                              ( 11yrs and above ), pool access, mist dance, use
                              of standard facilities of the resort.
                            </div>
                            <div class="gmail_default">
                              <b>Food and Beverage :&nbsp;</b>Welcome beverage,
                              Hi tea, Unlimited 2 veg + 2 non-veg starters and IMFL beverages at the bar for 90 minutes, dinner buffet.
                            </div>
                          </div>
                          <ul class="svelte-1wboxoc">
                            <li class="svelte-1wboxoc">
								<strong>Duration :</strong> 3pm to 10pm
                            </li>
                            <li class="svelte-1wboxoc">
                              Minimum group size 50 and above
                            </li>
                            <li class="svelte-1wboxoc">
                              <a
                                class="calluna-recent-posts-entry-img calluna-shortcodes-lightbox"
                                href="https://www.mangomist.com/dmd.html" target="_blank"
                                contenteditable="false"
                                style="cursor: pointer;">View Details</a
                              >
                            </li>
                          </ul>
                        </div>
						<div>
							<strong>
							INR 2,740 Per Adult
						</strong>
						</div>
						( Taxes applicable )
                      </div>
                      <div class="calluna-pricing-button svelte-1wboxoc">
                        <a
                          href="contact"
                          class="calluna-button btn btn-primary style-1 svelte-1wboxoc"
                          rel="nofollow"
                          contenteditable="false"
                          style="cursor: pointer;"
                          ><span class="calluna-button-inner"
                            ><span class="calluna-button-icon-left fa fa-adjust"
                            ></span>Contact Us<span
                              class="calluna-button-icon-right fa fa-adjust"
                            ></span></span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>
      <OffersSafetyMattersPriorBooking />
    </div>
  </div>
</div>

<style>
  .image-background {
    background: rgba(0, 0, 0, 0) url(../images/Amenities.jpg) repeat scroll 0 0;
  }
  .calluna-bullets ul li {
    padding-left: 25px !important;
  }

  .calluna-bullets-check ul li {
    background: url(images/check.png) left center no-repeat;
  }

  .calluna-bullets-gray ul li {
    background: url(images/bullets-gray.png) left center no-repeat;
  }

  .calluna-bullets-black ul li {
    background: url(images/bullets-black.png) left center no-repeat;
  }

  .calluna-bullets-blue ul li {
    background: url(images/bullets-blue.png) left center no-repeat;
  }

  .calluna-bullets-red ul li {
    background: url(images/bullets-red.png) left center no-repeat;
  }

  .calluna-bullets-purple ul li {
    background: url(images/bullets-purple.png) left center no-repeat;
  }

  .calluna-button.btn-primary,
  .calluna-button.large.btn-primary {
    font-size: 1.125rem;
    padding: 14px 36px;
  }

  .calluna-button.btn-primary {
    background-color: transparent;
    border: 2px solid #967a50;
    border-radius: 3px;
    color: #967a50;
    display: inline-block;
    font-weight: 500;
    letter-spacing: 0.1rem;
    text-align: center;
    text-transform: uppercase;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .calluna-pricing {
    list-style: none;
    text-shadow: none;
    margin-bottom: 0;
    border: 1px solid #ddd;
    transition: all 0.25s ease-in-out;
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
  }
  .calluna-pricing .calluna-pricing-header {
    background: #fff;
    text-align: center;
    padding: 0;
    margin: -1px -1px 0;
  }
  .calluna-pricing .calluna-pricing-header h4 {
    color: #fff;
    background-color: #0f2453;
    font-size: 1.2rem;
    line-height: 1;
    letter-spacing: 1px;
    margin: 0;
    padding: 18px 20px;
    font-weight: 500;
    text-transform: uppercase;
  }

  .calluna-pricing.featured .calluna-pricing-header h4 {
    color: #fff;
    background-color: #967a50;
  }

  .calluna-pricing .calluna-pricing-content {
    background: #fff;
    font-size: 1rem;
    text-align: center;
  }
  .calluna-pricing .calluna-pricing-content ul {
    margin: 0 !important;
    list-style: none !important;
    padding: 0 !important;
  }
  .calluna-pricing .calluna-pricing-content ul li {
    margin: 0 !important;
    padding: 18px 20px !important;
    border-bottom: 1px solid #eee;
    list-style: none !important;
  }
  .calluna-pricing .calluna-pricing-button {
    background: #fff;
    text-align: center;
    border-top: 1px solid #fff;
    padding: 25px 20px 30px;
  }
  .calluna-pricing .calluna-pricing-button .calluna-button {
    float: none;
    margin: 0 auto;
  }

  .day_out_box {
    width: 100%;
    display: flex;
    gap: 25px;
  }

  .day_out_mainbox {
    width: 50%;
  }

  .primary {
    background: rgba(0, 0, 0, 0) url(../images/gpattern-opacity-1.png) repeat
      scroll 0 0;
  }

  .day_out_mainbox {
    -moz-border-bottom-colors: none;
    -moz-border-left-colors: none;
    -moz-border-right-colors: none;
    -moz-border-top-colors: none;
    background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
    border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4)
      rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
    border-image: none;
    border-radius: 25px;
    box-shadow: 8px 8px 8px #888888;
    margin: 0 auto;
    position: relative;
    width: 48% !important;
    margin-bottom: 20px;
  }

  .page-id-3959 .calluna-pricing .calluna-pricing-content,
  .page-id-3959 .calluna-pricing .calluna-pricing-header,
  .page-id-3959 .calluna-pricing .calluna-pricing-button {
    background-color: rgba(248, 248, 248, 0);
  }

  .calluna-pricing .calluna-pricing-content ul li {
    border: none;
  }

  .day_out_box .calluna-pricing {
    border: medium none;
    min-height: 365px;
  }

  .calluna-pricing .calluna-pricing-header h4 {
    border-radius: 25px 25px 0 0;
  }

  .calluna-pricing .calluna-pricing-content ul li {
    padding: 5px 10px !important;
    border: none;
  }

  .calluna-pricing .calluna-pricing-button {
    padding: 20px 20px 10px;
    border: none;
  }

  @media only screen and (min-width: 320px) and (max-width: 600px) {
    .day_out_box {
      width: 100% !important;
      flex-flow: column;
    }

    .vc_column_container > .vc_column-inner {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }

    .day_out_mainbox {
      width: 100% !important;
    }

    .calluna-pricing .calluna-pricing-content {
      padding: 15px;
    }
  }

  strong, b {
    font-weight: bold;
  }
</style>
